export const pattern25Data = [
  {
    koreanChunks: ["성공은 온보딩 과정", "의존한다", "부서 간의 협력에"],
    englishChunks: [
      "The success of the onboarding process",
      "depends",
      "on department coordination",
    ],
    fullEnglish:
      "The success of the onboarding process depends on department coordination.",
    additionalExplanation:
      "원어민이 of를 쓰는 경우는 방금 말한 부분에 좀 더 연관된 내용을 이어서 설명하고 싶을 때 말합니다. 영어 자체가 핵심이 되는 대상을 먼저 말하고 그 대상에 대한 보충 설명을 뒤에 하게 됩니다. 성공이라고 일단 말하고 오브를 써서 그 성공이란 게 어떤 건지 더 구체적으로 of로 설명합니다. 읽을 때도 말할 때도 같은 순서로 읽으려고 노력합니다  ",
  },
  {
    koreanChunks: ["검토해 주세요 디테일을", "수정된 제안"],
    englishChunks: ["Please review the details", "of the revised proposal"],
    fullEnglish: "Please review the details of the revised proposal.",
    additionalExplanation:
      "of 뒤에 오는 내용은 항상 설명 또는 배경, 뒤에서 앞으로 해석하지 않도록 말할 때는 핵심 단어(디테일) 먼저 말하고 설명 추가(수정된 제안)하는 식으로 합니다",
  },
  {
    koreanChunks: [
      "출시가",
      "우리의 새로운 제품 라인",
      "공식적으로 (현재) 확인되었습니다",
    ],
    englishChunks: [
      "The launch",
      "of our new product line",
      "has been officially confirmed",
    ],
    fullEnglish:
      "The launch of our new product line has been officially confirmed.",
    additionalExplanation:
      "영어에서는 핵심 명사(launch)를 먼저 언급하고 'of'를 통해 부가 설명을 합니다.",
  },
  {
    koreanChunks: ["판매가", "전기차", "증가했습니다", "15% 까지 지난분기에"],
    englishChunks: [
      "Sales",
      "of electric vehicles",
      "rose",
      "by 15% last quarter",
    ],
    fullEnglish: "Sales of electric vehicles rose by 15% last quarter.",
    additionalExplanation:
      "말하고 싶은 것(판매)-> 설명(전기차)을 이어서 설명하는 방식에 익숙해져야 합니다.",
  },
  {
    koreanChunks: ["사본이", "직원 핸드북", "이용 가능합니다 온라인에서"],
    englishChunks: [
      "A copy",
      "of the employee handbook",
      "is available online",
    ],
    fullEnglish: "A copy of the employee handbook is available online.",
    additionalExplanation:
      "말하고 싶은 것(사본)-> 설명(직원 핸드북)을 이어서 설명하는 방식에 익숙해져야 합니다.",
  },

  {
    koreanChunks: ["사용은", "휴대폰", "금지되어 있습니다", "훈련실 안에서"],
    englishChunks: [
      "The use",
      "of mobile phones",
      "is prohibited",
      "in the training room",
    ],
    fullEnglish: "The use of mobile phones is prohibited in the training room.",
    additionalExplanation:
      "말하고 싶은 것(사용하는게)-> 설명(휴대폰을)을 이어서 설명하는 방식에 익숙해져야 합니다.",
  },
  {
    koreanChunks: ["활용하세요", "우리의 한정 시간 제안", "종료되기 전에"],
    englishChunks: [
      "Take advantage",
      "of our limited-time offer",
      "before it ends",
    ],
    fullEnglish: "Take advantage of our limited-time offer before it ends.",
    additionalExplanation:
      "말하고 싶은 것(활용해라)-> 설명(한정된 오퍼)을 이어서 설명하는 방식에 익숙해져야 합니다.",
  },

  {
    koreanChunks: ["완료는", "안전 교육", "의무적입니다", "모든 직원에게"],
    englishChunks: [
      "Completion",
      "of the safety training",
      "is mandatory",
      "for all staff",
    ],
    fullEnglish:
      "Completion of the safety training is mandatory for all staff.",
    additionalExplanation:
      "말하고 싶은 것(완료)-> 설명(안전 교육)을 이어서 설명하는 방식에 익숙해져야 합니다.",
  },
  {
    koreanChunks: ["CEO가 말했다", "회사의 계획에 대해", " 글로벌 확장에 관한"],
    englishChunks: [
      "The CEO spoke",
      "of the company's plans",
      "for global expansion",
    ],
    fullEnglish: "The CEO spoke of the company's plans for global expansion.",
    additionalExplanation:
      "말하고 싶은 것(말했다)-> 설명(회사의 계획)을 이어서 설명하는 방식에 익숙해져야 합니다.",
  },
  {
    koreanChunks: ["배포가", "출입 카드", "시작됩니다", "월요일에 "],
    englishChunks: [
      "Distribution",
      "of access cards",
      "will begin ",
      "on Monday",
    ],
    fullEnglish: "Distribution of access cards will begin on Monday.",
    additionalExplanation:
      "말하고 싶은 것(배포)-> 설명(출입카드)을 이어서 설명하는 방식에 익숙해져야 합니다.",
  },

  {
    koreanChunks: [
      "도착해서 늦게",
      "면접에",
      "지원자는 놓쳤습니다 그룹 소개를",
    ],
    englishChunks: [
      "Arriving late",
      "to the interview,",
      "the applicant missed the group introduction",
    ],
    fullEnglish:
      "Arriving late to the interview, the applicant missed the group introduction.",
    additionalExplanation:
      "원어민이 어떤 배경을 좀 얘기하고 싶을 때 이렇게 분사구문을 말을 합니다. 뒷부분을 들어야 물론 왜 얘기했는지 알게 되는데요. 즉 뒷부분을 보면 이 화자가 이 분사구문을 처음에 왜 언급했는지 알 수 있습니다. 뒷문장을 보고 앞의 분사구문을 볼 때 어떻게 해석할까? 생각해봅니다. 그리고 내가 이 문장을 말하려면 처음에 어떻게 분사구문을 말해야 할까도 생각해봅니다. 분사구문은 화자 입장에서는 처음부터 어떤 의도로 이 말을 띄우는지 의도가 확실하지만 읽는 사람 입장에선 처음엔 읽고 -> 뒷문장을 파악하고 나서야 왜 말했는지 알게 되는 구조입니다.",
  },
  {
    koreanChunks: [
      "따라서 귀하의 요청에,",
      "우리는 (현재) 첨부했습니다 업데이트된 인보이스를",
    ],
    englishChunks: [
      "Following your request,",
      "we have attached the updated invoice",
    ],
    fullEnglish:
      "Following your request, we have attached the updated invoice.",
    additionalExplanation:
      "뒤에 내용을 보면 왜 우리가 인보이스를 첨부했는지 알 수 있습니다. 요청했으니까 보냈으니 '요청에 따라' 라고 해석합니다.",
  },
  {
    koreanChunks: [
      "근무하더라도 원격으로,",
      "직원들은 여전히 로그인해야 합니다",
      "오전 9시까지",
    ],
    englishChunks: [
      "Working remotely,",
      "employees must still log in",
      "by 9 a.m.",
    ],
    fullEnglish: "Working remotely, employees must still log in by 9 a.m.",
    additionalExplanation:
      "직원들이 여전히 로그인해야 한다는 뒷문장을 보고 '아, 원격으로 근무하더라도'라고 알 수 있습니다. 읽을 때는 우선 읽고 뒷문장을 보고 의미파악을 하고, 말하는 사람 입장에서는 우선 상황을 설명하고, 그 상황에서도 지켜야 할 규칙을 말하고자 이렇게 분사구문을 활용했습니다.",
  },
  {
    koreanChunks: [
      "확장하면서 글로벌 입지를,",
      "회사는 개설했습니다",
      "세 개의 새 사무실을",
    ],
    englishChunks: [
      "Expanding its global presence,",
      "the company opened",
      "three new offices",
    ],
    fullEnglish:
      "Expanding its global presence, the company opened three new offices.",
    additionalExplanation:
      "회사가 세 개의 새 사무실을 개설했다는 뒷문장을 보고 '아, 글로벌 입지를 확장하면서'라고 이해할 수 있습니다. ",
  },
  {
    koreanChunks: [
      "승인되어 매니저에 의해,",
      "새 정책은 시행됩니다",
      "다음 주부터",
    ],
    englishChunks: [
      "Approved by the manager,",
      "the new policy takes effect",
      "next week",
    ],
    fullEnglish:
      "Approved by the manager, the new policy takes effect next week.",
    additionalExplanation:
      "새 정책이 다음 주부터 시행된다는 뒷문장을 보고 '아, 매니저에 의해 승인되어서'라고 이해할 수 있습니다. 화자는 새 정책이 시행됐다는 핵심내용 얘기하기 전에 배경을 설명하려 분사구문을 썼습니다. 읽는 사람 입장에선 우선 읽고, 왜 이야기했는지 알면 됩니다. ",
  },
  {
    koreanChunks: [
      "아이디어가",
      "그..",
      "유연한 근무시간이 향상시킨다는 생산성을",
      "(현재) 널리 받아들여졌다",
    ],
    englishChunks: [
      "The idea",
      "that",
      "flexible hours improve productivity",
      "has been widely accepted",
    ],
    fullEnglish:
      "The idea that flexible hours improve productivity has been widely accepted.",
    additionalExplanation:
      "화자 입장에서는 그냥 아이디어라고 말하면 너무 막연하니, 무슨 아이디어냐면, 하고 말하는 것입니다. 읽는 사람도 그저 그게 무슨 생각인지 구체화하며 영어 어순을 그대로 지켜서 읽으면 됩니다. 단지 보충설명이라는 것을 잊지 말아야 합니다.",
  },
  {
    koreanChunks: [
      "정책은 설명합니다 사실을",
      "그..",
      "모든 직원들이 반드시 완료해야 한다는 컴플라이언스 교육을",
    ],
    englishChunks: [
      "The policy outlines",
      "the fact",
      "that",
      "all employees must complete compliance training",
    ],
    fullEnglish:
      "The policy outlines the fact that all employees must complete compliance training.",
    additionalExplanation:
      "결론은 정책이 어떤 사실을 설명한다는 것입니다. '사실'이라는 단어 뒤에 'that'절이 이어져 구체적인 내용(모든 직원이 컴플라이언스 교육을 완료해야 한다는 것)을 설명합니다. 영어 어순을 따라 읽으면 자연스럽게 의미가 전달됩니다.",
  },
  {
    koreanChunks: [
      "우리는 지지합니다 권고안을",
      "그..",
      "신입 직원들이 받아야 한다는 온보딩을",
      "3일 이내에",
    ],
    englishChunks: [
      "We support the recommendation",
      "that",
      "new hires receive onboarding",
      "within 3 days",
    ],
    fullEnglish:
      "We support the recommendation that new hires receive onboarding within 3 days.",
    additionalExplanation:
      "이 문장에서는 '우리가 지지하는 것'이 무엇인지 구체적으로 설명하고 있습니다. '권고안'이라는 명사 뒤에 'that'절이 이어져 그 내용(신입 직원들이 3일 이내에 온보딩을 받아야 한다는 것)을 자세히 설명합니다. 영어 어순을 따라 읽으면 자연스럽게 의미가 전달됩니다.",
  },
  {
    koreanChunks: [
      "우리는 확인해야 합니다 가정을",
      "그..",
      "고객이 부담할 것이라는 추가 비용을",
    ],
    englishChunks: [
      "We need to confirm the assumption",
      "that",
      "the client will cover the additional costs",
    ],
    fullEnglish:
      "We need to confirm the assumption that the client will cover the additional costs.",
    additionalExplanation:
      "이 문장에서는 '우리가 확인해야 하는 것'이 무엇인지 구체적으로 설명하고 있습니다. '가정'이라는 명사 뒤에 'that'절이 이어져 그 내용(고객이 추가 비용을 부담할 것이라는 것)을 자세히 설명합니다. 영어 어순을 따라 읽으면 자연스럽게 의미가 전달됩니다.",
  },
  {
    koreanChunks: [
      "결정이",
      "(그..)감독이 발표한",
      "놀라게 했습니다 전체 팀을",
    ],
    englishChunks: [
      "The decision",
      "the director announced",
      "surprised the entire team",
    ],
    fullEnglish:
      "The decision the director announced surprised the entire team.",
    additionalExplanation:
      "관계대명사가 생략된 것입니다. 굳이 that을 쓰지 않고 이렇게 이어말하는 경우도 있습니다. 원어민 마음입니다. 그러나 영어 어순을 지켜서 읽으면 문제 없습니다. 한국식으로 바꾸지만 않으면 됩니다. 중간에 그.. 를 넣어서 읽고 말할 때도 속으로 (그..)를 원어민도 한다고 생각해보세요.",
  },
  {
    koreanChunks: [
      "정책이",
      "(그..)위원회가 승인한",
      "발효될 것입니다 다음 달에",
    ],
    englishChunks: [
      "The policy",
      "the committee approved",
      "will take effect next month",
    ],
    fullEnglish:
      "The policy the committee approved will take effect next month.",
    additionalExplanation:
      "이 문장에서도 관계대명사 'that'이 생략되었습니다. '정책'이라는 명사 뒤에 '위원회가 승인한'이라는 관계절이 바로 이어집니다. 영어 어순을 따라 읽으면 '정책이(주어) 발효될 것입니다(동사) 다음 달에(부사구)'라는 기본 구조가 명확해집니다. 중간에 삽입된 관계절은 주어인 '정책'을 수식합니다.",
  },
  {
    koreanChunks: [
      "후보자가",
      "(그..)우리가 면접한 어제",
      "보여주었습니다 강한 리더십을",
    ],
    englishChunks: [
      "The candidate",
      "we interviewed yesterday",
      "showed strong leadership",
    ],
    fullEnglish:
      "The candidate we interviewed yesterday showed strong leadership.",
    additionalExplanation:
      "이 문장에서도 관계대명사 'that'이 생략되었습니다. '후보자'라는 명사 뒤에 '우리가 어제 면접한'이라는 관계절이 바로 이어집니다. 영어 어순을 따라 읽으면 '후보자가(주어) 보여주었습니다(동사) 강한 리더십을(목적어)'라는 기본 구조가 명확해집니다. 중간에 삽입된 관계절은 주어인 '후보자'를 수식합니다.",
  },
  {
    koreanChunks: [
      "파트너십이",
      "(그..)우리 CEO가 소개한",
      "목표로 합니다 확장하는 것을",
      "새로운 시장으로",
    ],
    englishChunks: [
      "The partnership",
      "our CEO introduced",
      "aims to expand",
      "into new markets",
    ],
    fullEnglish:
      "The partnership our CEO introduced aims to expand into new markets.",
    additionalExplanation:
      "이 문장에서도 관계대명사 'that'이 생략되었습니다. '파트너십'이라는 명사 뒤에 '우리 CEO가 소개한'이라는 관계절이 바로 이어집니다. 영어 어순을 따라 읽으면 '파트너십이(주어) 목표로 합니다(동사) 새로운 시장으로 확장하는 것을(목적어구)'라는 기본 구조가 명확해집니다. 중간에 삽입된 관계절은 주어인 '파트너십'을 수식합니다.",
  },
  {
    koreanChunks: [
      "캠페인이",
      "(그..)우리가 시작한 지난 분기에",
      "초과했습니다 모든 기대치를",
    ],
    englishChunks: [
      "The campaign",
      "we launched last quarter",
      "exceeded all expectations",
    ],
    fullEnglish:
      "The campaign we launched last quarter exceeded all expectations.",
    additionalExplanation:
      "이 문장에서도 관계대명사 'that'이 생략되었습니다. '캠페인'이라는 명사 뒤에 '우리가 지난 분기에 시작한'이라는 관계절이 바로 이어집니다. 영어 어순을 따라 읽으면 '캠페인이(주어) 초과했습니다(동사) 모든 기대치를(목적어)'라는 기본 구조가 명확해집니다. 중간에 삽입된 관계절은 주어인 '캠페인'을 수식합니다.",
  },
  {
    koreanChunks: [
      "기능이",
      "(그..)우리 고객들이 요청한 가장 많이",
      "이제 (현재) 추가됬습니다.",
    ],
    englishChunks: [
      "The feature",
      "our customers requested most",
      "has now been added",
    ],
    fullEnglish: "The feature our customers requested most has now been added.",
    additionalExplanation:
      "이 문장에서도 관계대명사 'that'이 생략되었습니다. '기능'이라는 명사 뒤에 '우리 고객들이 가장 많이 요청한'이라는 관계절이 바로 이어집니다. 영어 어순을 따라 읽으면 '기능이(주어) 추가되었습니다(동사) 이제(부사)'라는 기본 구조가 명확해집니다. 중간에 삽입된 관계절은 주어인 '기능'을 수식합니다.",
  },
  {
    koreanChunks: ["그것은 전략입니다", "(그..)우리가 논의한", "어제 회의에서"],
    englishChunks: [
      "That's the strategy",
      "we discussed",
      "in yesterday's meeting",
    ],
    fullEnglish: "That's the strategy we discussed in yesterday's meeting.",
    additionalExplanation:
      "이 문장에서도 관계대명사 'that'이 생략되었습니다. '전략'이라는 명사 뒤에 '우리가 어제 회의에서 논의한'이라는 관계절이 바로 이어집니다. 영어 어순을 따라 읽으면 '그것은(주어) 전략입니다(동사+보어)'라는 기본 구조가 명확해집니다. 관계절은 보어인 '전략'을 수식합니다.",
  },
  {
    koreanChunks: [
      "이것이 그 버전입니다",
      "(그..)당신이 요청한 나에게 수정해 달라고",
    ],
    englishChunks: ["Here's the version", "you asked me to revise"],
    fullEnglish: "Here's the version you asked me to revise.",
    additionalExplanation:
      "이 문장에서도 관계대명사 'that'이 생략되었습니다. '버전'이라는 명사 뒤에 '당신이 나에게 수정해 달라고 요청한'이라는 관계절이 바로 이어집니다. 영어 어순을 따라 읽으면 '이것은(주어) 버전입니다(동사+보어)'라는 기본 구조가 명확해집니다. 관계절은 보어인 '버전'을 수식합니다.",
  },
  {
    koreanChunks: ["이것은", "공급업체입니다", "(그..)우리 매니저가 추천한"],
    englishChunks: ["This is", "the vendor", "our manager recommended"],
    fullEnglish: "This is the vendor our manager recommended.",
    additionalExplanation:
      "이 문장에서도 관계대명사 'that'이 생략되었습니다. '공급업체'라는 명사 뒤에 '우리 매니저가 추천한'이라는 관계절이 바로 이어집니다. 영어 어순을 따라 읽으면 '이것은(주어) 공급업체입니다(동사+보어)'라는 기본 구조가 명확해집니다. 관계절은 보어인 '공급업체'를 수식합니다.",
  },
  {
    koreanChunks: ["이것은 사무실입니다", "(그..)내가 예전에 일하던"],
    englishChunks: ["This is the office", "I used to work"],
    fullEnglish: "This is the office I used to work.",
    additionalExplanation: "(= the office where I used to work) ",
  },
  {
    koreanChunks: ["저것은 회의실입니다", "(그..)우리가 회의를 개최한"],
    englishChunks: ["That's the conference room", "we held the meeting"],
    fullEnglish: "That's the conference room we held the meeting.",
    additionalExplanation: "(= the conference room where we held the meeting) ",
  },
  {
    koreanChunks: ["그 해는 전환점을 표시했습니다", "(그..)회사가 설립된"],
    englishChunks: [
      "The year",
      "the company was founded",
      "marked a turning point",
    ],
    fullEnglish: "The year the company was founded marked a turning point.",
    additionalExplanation: "= the year when the company was founded",
  },
];
